export const convertPriceToNumber = (price: string) => {
  return parseFloat(price.replace(/[^0-9.]/g, ''));
};

export function formatPrice(price: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(price);
}
